import Decimal from "decimal.js";
export class ProfileObject {
    constructor(records = []) {
        this.map = new Map();
        for (const k of records) {
            this.map.set(k['key'], k);
        }
    }
    has(k) {
        return this.map.has(k);
    }
    getValue(k, defaultValue = null) {
        var _a, _b;
        const v = this.map.get(k);
        if (v === null || v === undefined) {
            return defaultValue;
        }
        if (v.value === undefined)
            return defaultValue;
        switch (v.type) {
            case 'string':
                return String(v.value);
            case 'amount': {
                // @ts-ignore
                return new Decimal(v.value).toString();
            }
            case 'number': {
                return Number((_a = v.value) !== null && _a !== void 0 ? _a : 0);
            }
            case 'boolean': {
                return Boolean((_b = v.value) !== null && _b !== void 0 ? _b : false);
            }
            case 'json': {
                if (typeof v.value === 'string')
                    return JSON.parse(v.value);
                return v.value;
            }
            case 'date': {
                throw new Error('date object not implemented');
                // return new Date(v.value);
            }
            default: {
                // @ts-ignore: v.type is not a valid type
                throw new Error(`unknown type '${v.type}'`);
            }
        }
    }
}
export function createProfileObject(records) {
    return new ProfileObject(records);
}
